import React, { useState , useEffect} from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import GraficoConsumo from "./GraficoConsumo";
import Conexao from "../../../../providers/Conexao";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import TonerSlider from "../../../../Componentes/TonerSlider";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Checkbox } from "primereact/checkbox";


export default function ModalSliderNiveisToner(props){
    const {coleta, nivelAlertaIndividual, setNivelAlertaIndividual} = props
    const [data, setData] = useState({
       idcoleta : -1,
       idempresa : -1,
       nivelalertaciano : 0,
       nivelalertamagenta : 0,
       nivelalertaamarelo : 0,
       nivelalertapreto : 0,
    })
   
    useEffect(()=>{
        console.log(data)
    }, [data])

      
    useEffect(()=>{
        if(nivelAlertaIndividual.open){
            if(nivelAlertaIndividual.coleta){
                setData({
                idColeta : nivelAlertaIndividual.coleta.idcoleta,
                idEmpresa : nivelAlertaIndividual.coleta.idempresa,
                idCliente : nivelAlertaIndividual.coleta.idcliente,
                alertaCiano	: nivelAlertaIndividual.coleta.alertaciano,
                alertaMagenta	: nivelAlertaIndividual.coleta.alertamagenta,
                alertaAmarelo	: nivelAlertaIndividual.coleta.alertaamarelo,
                alertaPreto	: nivelAlertaIndividual.coleta.alertapreto,
                nivelCiano : nivelAlertaIndividual.coleta.alertaciano === 't' ? nivelAlertaIndividual.coleta.nivelalertaciano : 0,
                nivelMagenta : nivelAlertaIndividual.coleta.alertamagenta === 't' ? nivelAlertaIndividual.coleta.nivelalertamagenta : 0,
                nivelAmarelo : nivelAlertaIndividual.coleta.alertaamarelo === 't' ? nivelAlertaIndividual.coleta.nivelalertaamarelo : 0,
                nivelPreto : nivelAlertaIndividual.coleta.alertapreto === 't' ? nivelAlertaIndividual.coleta.nivelalertapreto : 0,
                })
            }
            
        }
    }, [nivelAlertaIndividual.open])

    

    return <div >                                          
                <Dialog
                    header={"Níveis Alerta Individual"}
                    visible={nivelAlertaIndividual.open}         
                    style={{ width: '30vw', }} // Largura padrão
                    breakpoints={{ '960px': '75vw', '720px': '90vw' }} // Ajuste para telas menores
                    onHide={() => setNivelAlertaIndividual((prevData)=>[{
                        open : false, 
                        coleta : []
                    }])}
                >
                    <div className="grid gap-5" style={{marginTop : '10px'}}>
                        <div className="col-12 md:col-12 pr-10, pl-5" style={{paddingRight : '20px'}}>
                            {nivelAlertaIndividual.coleta ?
                            <>
                            
                            <TonerSlider 
                                    min={0}
                                    max={100}                                     
                                    cor = 'C' color='#1565C0' 
                                    checked={data.alertaCiano === 't'}
                                    disabledCheckBox={!nivelAlertaIndividual.coleta.nivelciano}
                                    valor={data.nivelCiano} 
                                    setChecked={(value)=>{
                                        setData((prevData)=>({
                                            ...prevData,
                                            alertaCiano	 : value ? 't' : 'f'
                                        }))
                                    }}
                                    onChange={(value)=>{
                                        if(value ===0 ){
                                            return
                                        }
                                        setData((prevData)=>({
                                            ...prevData,
                                            nivelCiano : value
                                        }))
                                    }}/>
                            <TonerSlider                                     
                                    cor = 'M' 
                                    color='#E91E63' 
                                    valor={ data.nivelMagenta} 
                                    checked={data.alertaMagenta === 't'}
                                    disabledCheckBox={!nivelAlertaIndividual.coleta.nivelmagenta}
                                    setChecked={(value)=>{
                                        console.log('Monitorar Magenta :' + value)
                                        setData((prevData)=>({
                                            ...prevData,
                                            alertaMagenta : value ? 't' : 'f'
                                        }))
                                    }}
                                    onChange={(value)=>{
                                        if(value ===0 ){
                                            return
                                        }
                                    setData((prevData)=>({
                                            ...prevData,
                                            nivelMagenta : value
                                        }))
                                    }}/>

                            <TonerSlider                                     
                                    cor = 'Y' color='#FBC02D' 
                                    valor={ data.nivelAmarelo} 
                                    disabledCheckBox={!nivelAlertaIndividual.coleta.nivelamarelo}
                                    checked={data.alertaAmarelo === 't'}
                                    setChecked={(value)=>{
                                        setData((prevData)=>({
                                            ...prevData,
                                            alertaAmarelo	 : value ? 't' : 'f'
                                        }))
                                    }}
                                    onChange={(value)=>{
                                        if(value ===0 ){
                                            return
                                        }
                                        setData((prevData)=>({
                                            ...prevData,
                                            nivelAmarelo : value
                                        }))
                                    }}/>

                            <TonerSlider                                     
                                    cor = 'K' 
                                    color='#000' 
                                    valor={ data.nivelPreto} 
                                    disabledCheckBox={!nivelAlertaIndividual.coleta.nivelpreto}
                                    checked={data.alertaPreto === 't'}
                                    setChecked={(value)=>{
                                        setData((prevData)=>({
                                            ...prevData,
                                            alertaPreto	 : value ? 't' : 'f'
                                        }))
                                    }}
                                    onChange={(value)=>{
                                        if(value ===0 ){
                                            return
                                        }
                                        setData((prevData)=>({
                                            ...prevData,
                                            nivelPreto : value
                                        }))
                                    }}/>

                            </>: null }
                        </div>
                    </div>
                    <div className="mt-4 flex justify-content-end mt-2">
                        <Button disabled={props.loading} severity="secondary" className="mt-2 mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                                confirmDialog({
                                message: 'Deseja cancelar?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: 'Sim',
                                rejectLabel: 'Não',
                                accept: () => {
                                   setNivelAlertaIndividual((prevData)=>[{
                                        open : false, 
                                        coleta : []
                                        }])
                                }
                            });
                        }} />

                        <Button disabled={props.loading} severity="primary" className="mt-2 mr-2" label="Salvar" icon="pi pi-save" onClick={() => {  
                                 

                                if(data.alertaCiano ==='f' && data.alertaMagenta ==='f' && data.alertaAmarelo ==='f' && data.alertaPreto ==='f' ){
                                    props.showMessageToast('error', 'Você precisa selecionar pelo menos uma cor para habilitar a função!')
                                    return;
                                }

                                let erroC, erroM, erroY, erroK = false;

                                if(data.alertaCiano ==='t' && !data.nivelCiano){
                                    props.showMessageToast('warn', 'Você precisa informar o percentual alvo do nível CIANO')
                                    erroC = true;
                                }else{
                                    erroC = false
                                }

                                if(data.alertaMagenta==='t' && !data.nivelMagenta){
                                    props.showMessageToast('warn', 'Você precisa informar o percentual alvo do nível MAGENTA')
                                    erroM = true; 
                                }else{
                                    erroM = false;
                                }

                                if(data.alertaAmarelo ==='t' && !data.nivelAmarelo){
                                    props.showMessageToast('warn', 'Você precisa informar o percentual alvo do nível AMARELO')
                                    erroY =true;
                                }else{
                                    erroY = false;
                                }

                                if(data.alertaPreto ==='t' && !data.nivelPreto){
                                    props.showMessageToast('warn', 'Você precisa informar o percentual alvo do nível PRETO')
                                    erroK =true; 
                                }   else{
                                    erroK = false
                                }  
                                if(erroC || erroM || erroY || erroK){
                                    return;
                                }    

                                confirmDialog({
                                message: 'Confirma confirmar os novos níveis de monitoramento de toner?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: 'Sim',
                                rejectLabel: 'Não',
                                accept: () => {
                                    let error = false;
                                    
                                    Conexao.post('coletasController/habilitarMonitoramentoSuprimentos', {
                                        ...data
                                    }).then(response=>{
                                        if(response.status === 200 && response.data.status ==='OK'){
                                            props.setColetasNiveis({
                                                alertaciano : data.alertaCiano, 
                                                nivelalertaciano : data.nivelCiano, 
                                                alertamagenta : data.alertaMagenta, 
                                                nivelalertamagenta :data.nivelMagenta, 
                                                alertaamarelo : data.alertaAmarelo,  
                                                nivelalertaamarelo : data.nivelAmarelo, 
                                                alertapreto : data.alertaPreto, 
                                                nivelalertapreto : data.nivelPreto, 
                                            })
                                            props.showMessageToast('success', 'Registro atualizado com sucesso!')
                                            setNivelAlertaIndividual((prevData)=>[{
                                        open : false, 
                                        coleta : []
                                        }])
                                        }else{
                                            props.showMessageToast('warn', 'Não foi possivel atualizar!')
                                        }
                                    }).catch(error=>{
                                        props.showMessageToast('error', 'Não foi possivel atualizar!')
                                    })
                                }
                                });
                        }} />
                    </div>

                </Dialog>
 </div>
}

            
            